import {
    LocaleState,
    ChangeLanguageAction,
    ToggleLanguageSelectionVisibilityAction,
    LoadLanguageServiceFromServerAction
} from "./type";
import { LanguageCodes } from "../../constants/languages";
import { LanguageLocaleService } from "../../services/Language/LanguageService";

export function changeApplicationLanguage(state: LocaleState, action: ChangeLanguageAction): LocaleState {
    try {
        if (!Object.values(LanguageCodes).includes(action.payload.lang)) {
            throw new Error("Language not part of list")
        }
        return Object.assign({}, state, {
            lang: action.payload.lang,
            currentLanguageText: state.textLibrary && state.textLibrary.setAndGetCurrentLanguageResource(action.payload.lang)
        });
    } catch {
        return Object.assign({}, state, {
            lang: LanguageCodes.English,
            currentLanguageText: state.textLibrary.setAndGetCurrentLanguageResource(LanguageCodes.English)
        });
    }
}

export function ToggleLanguageSelectionVisibilityHandler(
    state: LocaleState,
    action: ToggleLanguageSelectionVisibilityAction
) {
    return Object.assign({}, state, { showLanguageSelection: action.payload.show });
}

export function loadLanguageServiceFromServerHandler(state: LocaleState, action: LoadLanguageServiceFromServerAction) {
    const textLibrary = new LanguageLocaleService(action.payload.textLibrary);
    return Object.assign({}, state, {
        textLibrary,
        currentLanguageText: textLibrary.setAndGetCurrentLanguageResource(state.lang)
    });
}



// WEBPACK FOOTER //
// ./src/store/LanguageLocale/handlers.ts